import { makeStyles } from '@material-ui/styles'
import { deauthResMgrHost } from 'app/plugins/infrastructure/components/resMgrHosts/actions'
import ModalForm from 'core/elements/modal/ModalForm'
import Text from 'core/elements/Text'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { SessionState, sessionStoreKey } from 'core/session/sessionReducers'
import Theme from 'core/themes/model'
import { prop } from 'ramda'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

const useStyles = makeStyles<Theme>((theme) => ({
  fields: {
    gap: 16,
    display: 'grid',
  },
}))

const DeauthVmwareGatewayDescription = () => {
  return (
    <>
      <Text variant="body2">{`You are about to deauthorize the VMware Gateway.`}</Text>
      <Text variant="caption1">
        IMPORTANT: De-authorizing the VMware Gateway will remove it from Rackspace OpenCloud, along
        with all the Virtual Machines, Images, and Volumes running on vCenter.
      </Text>
    </>
  )
}

const DeauthHostDescription = ({ name }) => {
  return (
    <>
      <Text variant="body2">{`You are about to deauthorize ${name}.`}</Text>
    </>
  )
}

interface Props {
  rows: any[]
  onClose: () => void
}

export default function ToggleMaintenanceModeDialog({ rows: hosts, onClose }: Props) {
  const classes = useStyles()
  const host = hosts[0]

  const session = useSelector(prop<string, SessionState>(sessionStoreKey))
  const { features } = session
  const isVmware = features?.experimental?.pmov2_du_type === 'vmware'

  const { update: deauthorizeHost, updating: deauthorizingHost, error } = useUpdateAction(
    deauthResMgrHost,
  )

  const handleSubmit = useCallback(async () => {
    const response = await deauthorizeHost(host)
    if (response.success) {
      onClose()
    }
  }, [host, onClose])

  return (
    <ModalForm
      title={isVmware ? 'Deauthorize VMware Gateway' : 'Deauthorize Host'}
      onSubmit={handleSubmit}
      onClose={onClose}
      loading={false}
      submitting={deauthorizingHost}
      error={error}
      submitTitle={`Deauthorize`}
      panel="dialog"
      open
    >
      <div className={classes.fields}>
        {isVmware ? <DeauthVmwareGatewayDescription /> : <DeauthHostDescription name={host.name} />}
      </div>
    </ModalForm>
  )
}
